import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import ProductBasicInformation from './NewBlogForms/ProductBasicInformation';
import ProductHeader from './NewBlogForms/ProductHeader';
import ProductUpdateUpload from './NewBlogForms/ProductUpdateUpload';
import ProductDetails from './NewBlogForms/ProductDetails';
import ProductType from './NewBlogForms/ProductType';
import ProductTags from './NewBlogForms/ProductTags';
import { useMutation, useQuery } from '@apollo/client';
import { BLOG_POST_UPDATE, BLOG_BY_ID } from '../../../lib/mutations';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Resizer from 'react-image-file-resizer';

const schema = yup
  .object({
    title: yup.string().required('Энэ талбарыг оруулна уу!'),
    description: yup.string().required('Энэ талбарыг оруулна уу!'),
    category: yup.string().required('Энэ талбарыг оруулна уу!')
  })
  .required();

// const cloudinaryURLToDropzoneFile = async (url, filename) => {
//   return await fetch(url)
//     .then(response => response.blob())
//     .then(blob => {
//       const file = new File([blob], filename, { type: blob.type });
//       return file;
//     });
// };

const BlogUpdate = () => {
  let navigage = useNavigate();
  const { blogId } = useParams();
  const [updateBlogData, { data }] = useMutation(BLOG_POST_UPDATE);
  const { data: getBlogOne } = useQuery(BLOG_BY_ID, {
    variables: { blogId }
  });
  // images
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const { handleSubmit, reset } = methods;
  const imageUploader = image => {
    setLoading(true);
    Resizer.imageFileResizer(
      image,
      800,
      600,
      'WEBP',
      100,
      0,
      uri => {
        axios
          .post(`${process.env.REACT_APP_FILE_URL}/uploadimage`, {
            image: uri
          })
          .then(response => {
            if (response.data?.url && response.data?.public_id) {
              const newImageUrl = {
                url: String(response?.data?.url),
                public_id: String(response?.data?.public_id),
                bucketname: image.name
              };

              setImageUrls(prevUrls => [...prevUrls, newImageUrl]);
              setLoading(false);
            }
          })
          .catch(error => {
            console.log('CLOUDINARY UPLOAD FAILED', error);
          });
      },
      'base64',
      400,
      300
    );
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      updateBlogData({
        variables: {
          input: {
            category: data.category,
            description: data.description,
            image: imageUrls,
            tags:
              data.tags && Array.isArray(data.tags) && data.tags.length > 0
                ? [...data.tags.map(item => item.value)]
                : [],
            title: data.title
          },
          blogId
        }
      });
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = '';
      }
      reset({ ...submittedValues });
      navigage('/blogs/blog-list');
    }
  };

  useEffect(() => {
    if (getBlogOne) {
      const { title, description, category, tags, image } =
        getBlogOne.blogById.data;
      reset({
        title,
        description,
        category,
        tags: tags.map(tag => ({ value: tag, label: tag }))
      });
      const buffer = [];
      image.forEach(item => {
        const newFile = {};
        Object.assign(newFile, {
          path: item.bucketname,
          preview: item.url
        });
        buffer.push(newFile);
      });
      const updatedData = image.map(item => {
        const obj = {};
        obj.url = item.url;
        obj.bucketname = item.bucketname;
        obj.public_id = item.public_id;
        return obj;
      });
      setImageUrls(updatedData);
      setFiles(buffer);
    }
  }, [getBlogOne, reset]);

  useEffect(() => {
    if (data) {
      if (data?.blogUpdate?.status?.code === 200) {
        toast.success(`Амжиллтай илгээлээ`, {
          theme: 'colored'
        });
      } else {
        toast.warning(`${data?.blogUpdate?.status?.moreInfo}`, {
          theme: 'colored'
        });
      }
    }
  }, [data]);

  const handleRemove = path => {
    let removeItem = '';
    imageUrls.forEach(item => {
      if (item.bucketname === path) {
        removeItem = item.public_id;
      }
    });
    setFiles(files.filter(file => file.path !== path));
    const updatedImageUrls = imageUrls.filter(
      image => image.bucketname !== path
    );
    setImageUrls(updatedImageUrls);
    if (removeItem) {
      axios
        .post(`${process.env.REACT_APP_FILE_URL}/removeimage`, {
          public_id: removeItem
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={12}>
            <ProductHeader />
          </Col>
          <Col lg={8}>
            <ProductBasicInformation />
            <ProductUpdateUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
            <ProductDetails />
          </Col>
          <Col lg={4}>
            <div className="sticky-sidebar">
              <ProductType />
              <ProductTags />
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default BlogUpdate;
